module.exports = __webpack_public_path__ + "static/media/son-quote-poster.6e4e5fdc.webp";